/**
 * Collapse Arabic spelling variants so "عبد الرحمن" matches "عبدالرحمن".
 */
export function normalizeEmployeeSearchText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[أإآٱ]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ة/g, "ه")
    .replace(/[\s\u0640_\-./\\,]+/g, "");
}

export function employeeMatchesSearch(emp, query) {
  const q = String(query || "").trim();
  if (!q) return false;

  const tokens = q
    .split(/\s+/)
    .map((part) => normalizeEmployeeSearchText(part))
    .filter(Boolean);
  if (!tokens.length) return false;

  const haystacks = [emp?.name, emp?.fullName, emp?.code, emp?.employeeCode]
    .map((text) => normalizeEmployeeSearchText(text))
    .filter(Boolean);

  if (
    tokens.every((token) => haystacks.some((text) => text.includes(token)))
  ) {
    return true;
  }

  const qNorm = normalizeEmployeeSearchText(q);
  if (qNorm && haystacks.some((text) => text.includes(qNorm))) {
    return true;
  }

  if (/^\d+$/.test(qNorm)) {
    return [emp?.code, emp?.employeeCode].some((text) => {
      const digits = String(text || "").replace(/\D/g, "").replace(/^0+/, "") || "0";
      return digits === qNorm || digits.endsWith(qNorm);
    });
  }

  return false;
}
